// removed by extract-text-webpack-plugin
module.exports = {"PaginationButtonGroup":"PaginationButton__-loca-__10pRQ","PaginationHelper":"PaginationButton__-loca-__1nxBm","ButtonText":"PaginationButton__-loca-__3qzQv","Image":"PaginationButton__-loca-__1UBGz","PaginationGroup":"PaginationButton__-loca-__yMwtR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/PaginationButton/PaginationButton.css
// module id = 209
// module chunks = 0